import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { formatDateString } from "../../utils/outbound-labels-utils";

const catalogEntry = fgColumnEntries.pickedAt;

export const PickedAtColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => (
    <RedoTableTextCell
      subtext={row?.pickedAt
        ?.toLocaleTimeString(undefined, {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        })
        .toLowerCase()}
      text={
        row.pickedAt ? formatDateString(row.pickedAt.toISOString(), false) : ""
      }
    />
  ),
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
};
